import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import POS from './pages/POS';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Sales from './pages/Sales';
import Promotions from './pages/Promotions';
import Users from './pages/Users';
import Roles from './pages/Roles';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Categories from './pages/Categories';
import Members from './pages/Members';
import StockCount from './pages/StockCount';
import StockHistory from './pages/StockHistory';
import CustomerDisplay from './pages/CustomerDisplay';
import Layout from './components/Layout';
import { settingsAPI } from './services/api';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

function App() {
  // Load store settings and update document title and favicon
  useEffect(() => {
    const loadSettings = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const response = await settingsAPI.get();
          const storeName = response.data.store_name || 'pos.ekkapan.com';
          document.title = storeName;

          // Update favicon if store logo exists
          if (response.data.store_logo) {
            const favicon = document.querySelector("link[rel*='icon']");
            if (favicon) {
              favicon.href = response.data.store_logo;
            } else {
              // Create favicon link if it doesn't exist
              const newFavicon = document.createElement('link');
              newFavicon.rel = 'icon';
              newFavicon.href = response.data.store_logo;
              document.head.appendChild(newFavicon);
            }
          }
        }
      } catch (error) {
        console.error('Error loading settings for title:', error);
      }
    };
    loadSettings();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/customer-display" element={<CustomerDisplay />} />

        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Navigate to="/pos" />} />
          <Route path="pos" element={<POS />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="categories" element={<Categories />} />
          <Route path="members" element={<Members />} />
          <Route path="sales" element={<Sales />} />
          <Route path="promotions" element={<Promotions />} />
          <Route path="stock-count" element={<StockCount />} />
          <Route path="stock-history" element={<StockHistory />} />
          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
